import styles from './Reviews.module.scss';

import TrustPilotReviews from './components/TrustPilotReviews';
import GoogleReviews from './components/GoogleReviews';
import { Section } from '../Section';
import clsx from 'clsx';

export const Reviews = ({ className }: { className?: string }) => {
  return (
    <Section className={clsx(styles.reviews, className)}>
      <TrustPilotReviews />
      <GoogleReviews />
    </Section>
  );
};
